import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('targets', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        show: (cntx, { id }) => {
            axios.get(`targets/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        saveTarget: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.post('targets', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        updateTarget: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.put(`targets/${params.id}`, params.data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        seasons: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('seasons', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        locations: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('locations', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    }
}
